import { Violations } from 'Components/common/Violations/Violations'
import { ViolationsType } from 'shared/violations/types'
import { ContainerType, TaskConfigType } from 'Types/Tasks.types'

type ViolationsElementPropsType = {
    violations: ViolationsType
    taskConfig: TaskConfigType<ContainerType, unknown>
}

export const ViolationsElement = (props: ViolationsElementPropsType) => {
    return (
        <div>
            <Violations violations={props.violations} taskConfig={props.taskConfig} />
        </div>
    )
}
